// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import AudioTransformDevice from './AudioTransformDevice';
import Device from './Device';

type AudioInputDevice = Device | AudioTransformDevice | null;

export default AudioInputDevice;
